import { Input } from "@web-app/components";
import { ChecklistItem } from "@web-app/types";

type ChecklistSummaryProps = {
  items: ChecklistItem[];
  // When set, the checkboxes can be ticked; otherwise they're read-only.
  onToggle?: (index: number, isChecked: boolean) => void;
};

// A leg's checklist: checkbox, label, then "x N" when the item has a
// quantity. General items without a quantity show the label only.
export default function ChecklistSummary({
  items,
  onToggle,
}: ChecklistSummaryProps) {
  return (
    <ul className="flex flex-col gap-1">
      {items.map((item, index) => (
        <li key={index} className="flex items-center gap-2">
          <Input
            type="checkbox"
            value={item.isChecked ? "true" : "false"}
            readOnly={!onToggle}
            onChange={(value: string) => onToggle?.(index, value === "true")}
            aria-label={`${item.label} ${item.isChecked ? "checked" : "not checked"}`}
            labelClassName={onToggle ? undefined : "pointer-events-none"}
          />
          <span>{item.label}</span>
          {!!item.quantity && (
            <span className="text-gray-500">x {item.quantity}</span>
          )}
        </li>
      ))}
    </ul>
  );
}
